export default __webpack_public_path__ + "static/header-iconic-link-products-link-icon1.url-53e508d738d24cd58169209a35701d2f.svg";